var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"plan"}},[_c('div',{staticClass:"plan-home"},[_c('img',{attrs:{"src":require("../../../assets/image/plan1.jpg"),"alt":""}})])])}]

export { render, staticRenderFns }